import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Helper } from '../../../../utils/helper';
import { CommonModule } from '@angular/common'; // Import CommonModule

import { ReactiveFormsModule } from '@angular/forms';

import { BlockTextComponent } from '../../common/block-text/block-text.component';
import {
  PushInitModel,
  PushInitVariables,
  PushModel,
  PushVariables,
} from '../../../../models/push-template/push.interface';
import { NotificationComponent } from '../../common/notification/notification.component';
import { PinComponent } from '../../common/pin/pin.component';
import { BaseComponent } from '../../common/BaseComponent';
import { VariableMaxLengthService } from '../../../../services/variable-max-length.service';

@Component({
    selector: 'app-push',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        BlockTextComponent,
        NotificationComponent,
        PinComponent,
    ],
    templateUrl: './push.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './push.component.scss'
})
export class PushComponent extends BaseComponent implements OnInit {
  @Input() block: PushModel = new PushInitModel();
  @Input() isPreview = false;
  @Output() blockData = new EventEmitter<any>();
  @Output() removeBlockEvent = new EventEmitter<string | null>();

  currentTime: string = new Date().toISOString().slice(11, 16);

  count: number = 0;

  ngOnInit() {
    if (Helper.isEmpty(this.block.variables!)) {
      this.block.variables = new PushInitVariables()
    }
  }

  //placeholders:
  pushCopyPlaceHolder = "Enter copy text";
  pushLinkPlaceHolder = "Enter link";
  pushSubjectPlaceHolder = "Enter subject text";
  pushTitlePlaceHolder = "Enter title text";

  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId);
  }

  onChange(value: any, fieldName: keyof PushVariables) {
    if (this.block.variables) {
      this.block.variables[fieldName] = value;
      this.blockData.emit(this.block);
    }
  }

  onContainerClick(event: MouseEvent) {
    // Forward the click event to the child app-pin component
    this.pinComponent.onContainerClick(event);
  }
}
